import React from 'react';
import { formatUSD } from 'helpers/money.helper';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import classnames from 'classnames';

const NegativeMarksAccountsItem = ({
  accounts,
  className,
  datatestid,
  removeBorder = false,
}) => {
  const negativeMarkLegend = negativeMarkType => {
    if (negativeMarkType === 'Derogatory') {
      return (
        <div className="inblock margr8 width8px height8px bgRed100 border-rad50" />
      );
    }
    return (
      <div className="inblock margr8 width8px height8px bgYellow075 border-rad50" />
    );
  };

  return (
    <div
      data-testid={datatestid ? `${datatestid}-list` : null}
      className={classnames('listBlock', className)}
    >
      {accounts.map((item, index) => {
        return (
          <FlexContainer
            key={`${item.name}-${item.accountType}-${index}`}
            justifyBetween
            className={classnames('padtb20', {
              borderBmGray050: !removeBorder,
            })}
          >
            <FlexContainer column>
              <div
                data-testid={datatestid ? `${datatestid}-name` : null}
                className="mainItem"
              >
                {item.name}
              </div>
              <div
                data-testid={datatestid ? `${datatestid}-subItem` : null}
                className="subItem text-14 m-text-12 formatMaxContent"
              >
                {item.accountType}
              </div>
            </FlexContainer>
            <FlexContainer column className="items-align-end">
              <div
                data-testid={datatestid ? `${datatestid}-pastDue` : null}
                className="mainItem bold "
              >
                Past due: {formatUSD(item.pastDue)}
              </div>
              <div
                data-testid={datatestid ? `${datatestid}-remark` : null}
                className="subItem text-14 m-text-12 formatMaxContent"
              >
                {negativeMarkLegend(item.negativeMarkType)}
                {item.negativeMarkType}: {item.remark}
              </div>
            </FlexContainer>
          </FlexContainer>
        );
      })}
    </div>
  );
};

export default NegativeMarksAccountsItem;
